export default "__VITE_ASSET__e9b8ad0a__"